import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getBrands = () => {
  const url = `${API_URL}/api/v1/brand`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetBrands(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetBrands(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetBrands({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetBrands = (data) => ({
  type: types.bmGetBrands,
  payload: data,
});

export const createBrand = (name) => {
  const url = `${API_URL}/api/v1/brand/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.post(url, { name }, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setCreateBrand(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        dispatch(setCreateBrand(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setCreateBrand({ status: 'danger', error: true, message }));
      });
  };
};

export const setCreateBrand = (data) => ({
  type: types.bmCreateBrand,
  payload: data,
});

export const updateBrand = (brandId, name) => {
  const url = `${API_URL}/api/v1/brand/edit/${brandId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.put(url, { name }, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setUpdateBrand(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        dispatch(setUpdateBrand(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setUpdateBrand({ status: 'danger', error: true, message }));
      });
  };
};

export const setUpdateBrand = (data) => ({
  type: types.bmUpdateBrand,
  payload: data,
});

export const deleteBrandById = (brandId) => {
  const url = `${API_URL}/api/v1/brand/${brandId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteBrandById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        outputData['brandId'] = brandId;
        dispatch(setDeleteBrandById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteBrandById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteBrandById = (data) => ({
  type: types.bmDeleteBrandById,
  payload: data,
});
